import React, { useState, createContext, useContext } from 'react';
import { cn } from '@/lib/utils';
import { X, CheckCircle2, AlertCircle, Info } from 'lucide-react';

const ToastCtx = createContext({ toast: () => {} });
export const useToast = () => useContext(ToastCtx);

let idCounter = 0;

export const ToastProvider = ({ children }) => {
  const [items, setItems] = useState([]);
  const toast = ({ title, description, variant = 'default', duration = 4000 }) => {
    const id = ++idCounter;
    setItems((s) => [...s, { id, title, description, variant }]);
    setTimeout(() => setItems((s) => s.filter((t) => t.id !== id)), duration);
  };
  const dismiss = (id) => setItems((s) => s.filter((t) => t.id !== id));
  return (
    <ToastCtx.Provider value={{ toast }}>
      {children}
      <div className="fixed top-6 right-6 z-[200] flex flex-col gap-3 max-w-sm">
        {items.map((t) => (
          <ToastItem key={t.id} {...t} onClose={() => dismiss(t.id)} />
        ))}
      </div>
    </ToastCtx.Provider>
  );
};

const ToastItem = ({ title, description, variant, onClose }) => {
  const Icon = variant === 'success' ? CheckCircle2 : variant === 'error' ? AlertCircle : Info;
  const color = variant === 'success' ? 'border-volt text-volt' : variant === 'error' ? 'border-[#FF3B30] text-[#FF3B30]' : 'border-white/20 text-white';
  return (
    <div
      data-testid="toast"
      className={cn('bg-surface border px-4 py-3 flex items-start gap-3 animate-fade-up', color)}
    >
      <Icon size={18} className="mt-0.5 flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="font-bold uppercase tracking-wider text-xs text-white">{title}</div>
        {description && <div className="text-xs text-white/60 mt-0.5">{description}</div>}
      </div>
      <button onClick={onClose} className="text-white/40 hover:text-white" aria-label="dismiss">
        <X size={14} />
      </button>
    </div>
  );
};
